import { Theme } from '@tanium/theme-data';
import { getGlobalContainerStyles, StyledFunctionArgs } from './getGlobalContainerStyles';
import { linkStyle } from './linkStyle';

// Following same approach as css() from @tanium/style-system here. The args for this
// function are "deliberately non-specific due to conflicts between it and the typings
// for other libraries, specifically emotion".
// The assumption is that it also will be passed directly to styled().
export const getGlobalStyles = (props?: Theme | StyledFunctionArgs) => [
  ...getGlobalContainerStyles(props),
  linkStyle,
];
